import { useState } from 'react'
import { siteTemplateApi } from '../utils/api'

// ── §96 Template/Remix System ─────────────────────────────────────────────────

const CATEGORIES = [
  { value: 'landing', label: 'Landing Page' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'portfolio', label: 'Portfolio' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'saas', label: 'SaaS' },
  { value: 'blog', label: 'Blog' },
  { value: 'general', label: 'General' },
]

interface Props {
  siteId: string
  siteName: string
  onClose: () => void
  onSaved?: () => void
}

export function SaveAsTemplateModal({ siteId, siteName, onClose, onSaved }: Props) {
  const [category, setCategory] = useState('general')
  const [description, setDescription] = useState('')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [error, setError] = useState('')

  async function handleSave() {
    setSaving(true)
    setError('')
    try {
      await siteTemplateApi.saveAsTemplate(siteId, { category, description: description.trim() || undefined })
      setSaved(true)
      onSaved?.()
      setTimeout(onClose, 1500)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка сохранения')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 9900, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
    >
      <div style={{ background: 'var(--bg-1)', borderRadius: 16, width: '100%', maxWidth: 480, boxShadow: '0 24px 64px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 24px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--text-primary)' }}>📦 Сохранить как шаблон</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>§96 · «{siteName}»</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 22, color: 'var(--text-muted)', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {saved ? (
            <div style={{ textAlign: 'center', padding: '24px 0', color: '#16a34a', fontSize: 16, fontWeight: 700 }}>
              ✅ Шаблон сохранён! Он появится в галерее шаблонов.
            </div>
          ) : (
            <>
              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6 }}>
                  Категория
                </label>
                <select
                  value={category}
                  onChange={e => setCategory(e.target.value)}
                  style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, background: 'var(--bg-2)', color: 'var(--text-primary)', cursor: 'pointer' }}
                >
                  {CATEGORIES.map(c => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6 }}>
                  Описание <span style={{ fontWeight: 400, textTransform: 'none' }}>(необязательно)</span>
                </label>
                <textarea
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  placeholder="Краткое описание шаблона..."
                  rows={3}
                  style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, background: 'var(--bg-2)', color: 'var(--text-primary)', resize: 'vertical', boxSizing: 'border-box' }}
                />
              </div>

              {error && (
                <div style={{ padding: '8px 12px', background: '#fee2e2', color: '#991b1b', borderRadius: 8, fontSize: 12 }}>{error}</div>
              )}

              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 4 }}>
                <button onClick={onClose} style={{ padding: '9px 18px', background: 'var(--bg-2)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, color: 'var(--text-primary)', cursor: 'pointer' }}>
                  Отмена
                </button>
                <button
                  onClick={() => void handleSave()}
                  disabled={saving}
                  style={{ padding: '9px 18px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1 }}
                >
                  {saving ? 'Сохранение...' : '📦 Сохранить шаблон'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
